import { useEffect, useRef } from "react";
import { atom } from "jotai";
import { useAtom } from "jotai";
import { atomFamily } from "jotai/utils";

const dashboardUiStateAtomFamily = atomFamily((key) => atom(undefined));

export function useDashboardUiState(key, initialValue) {
  const initialRef = useRef(initialValue);
  const [value, setValue] = useAtom(dashboardUiStateAtomFamily(key));

  useEffect(() => {
    if (value === undefined) {
      setValue(initialRef.current);
    }
  }, [setValue, value]);

  return [value === undefined ? initialRef.current : value, setValue];
}

